import { useServices } from './useServices';

export const useFileCache = () => {
  return useServices().fileCache;
};
